<template>
  <div>
    <van-popup 
      v-model="iframeType" 
      position="right"
      :style="{ height: '100%', width: '100%' }"
      class="iframe_popup"
      id="iframe_popup"
    >
      <div class="iframe_main">
        <!-- <div class="iframe_header_right" id="iframe_header_right_top" @click="iframeType=false, iframe_url=''" @touchmove="btn_touchmove" @touchend="btn_touchend">
          <div class="btn back" id="iframe_back">
            <i class="material-icons icon">&#xe837;</i>
          </div>
        </div> -->
        <div class="iframe_header_right" id="iframe_header_right_top" @click="iframeType=false, iframe_url=''">
          <div class="btn back" id="iframe_back">
            <i class="material-icons icon">&#xe888;</i>
          </div>
        </div>
        <iframe :src="iframe_url" class="iframe_content" id="iframeDiv" frameborder="0"></iframe>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: "IframePopup",
  components: {},
  data() {
    return {
      iframeType: false, //门店查询
      iframe_url: '', //iframe嵌套页面链接
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    //弹出iframe嵌套页面框架
    iframeShow(tmp_url){
      const _this = this;

      _this.iframe_url = tmp_url;

      _this.iframeType = true;
      
    },

    //iframe 关闭按钮拖拽
    btn_touchmove: function(e){
      e.preventDefault();
      let $iframe = document.getElementById("iframe_header_right_top");

      let moveEndX = e.touches[0].pageX - ($iframe.clientWidth / 2);
      let moveEndY = e.touches[0].pageY - document.body.scrollTop - ($iframe.clientHeight / 2);
      
      if( moveEndY < 0 ){
        moveEndY = 0;
      }
      
      if( moveEndY > document.body.clientHeight - $iframe.clientHeight ){
        moveEndY = document.body.clientHeight - $iframe.clientHeight;
      }

      $iframe.style.top = moveEndY+'px';
      $iframe.style.left = moveEndX+'px';
      $iframe.style.bottom = "auto";
      $iframe.style.right = "auto";
      
    },
    btn_touchend: function(e){
      const _this = this;
      
      let $iframe = document.getElementById("iframe_header_right_top");

      if( e.changedTouches[0].pageX < (document.body.clientWidth / 2) ){
        $iframe.style.transition = "all 0.3s;"
        $iframe.style.left = "5px";
      }else{
        $iframe.style.transition = "all 0.3s;"
        $iframe.style.left = (document.body.clientWidth - $iframe.clientWidth - 5)+'px';
      }
    }
  },
};
</script>

<style lang="less">
.iframe_popup {
  .iframe_header_right {
    position: absolute;
    z-index: 10;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 30px;
    background-color: rgba(0, 0, 0, .28);
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    color: #fff;
    .btn {
      width: 100%;
      height: 100%;
      color: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        font-size: 21px;
      }
    }
  }
  .iframe_main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    .iframe_content {
      border: none;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IframePopup.vue